import { Component } from '@theme/component';

const wowMenuStyle = `
@media (min-width: 990px) {
  #header-component .menu-list__trigger { display:inline-flex!important; align-items:center!important; gap:4px!important; }
  #header-component .menu-list__trigger > .menu-list__link { pointer-events:auto; cursor:pointer; }
  #header-component .menu-list__disclosure {
    position:static!important;
    inset:auto!important;
    width:auto!important;
    height:auto!important;
    padding:0 0 0 2px!important;
    opacity:1!important;
    transform:none!important;
    pointer-events:auto!important;
    display:inline-flex!important;
    align-items:center!important;
    justify-content:center!important;
    background:transparent!important;
    color:inherit!important;
  }
  #header-component .menu-list__disclosure-icon { display:block!important; width:8px!important; height:auto!important; margin:0!important; }
}
`;

class HeaderMenu extends Component {
  requiredRefs = ['overflowMenu'];

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('keydown', this.#onKeydown);
        this.addEventListener('click', this.#onHeadingClick, true);
            this.#prepareHeadings();
    document.addEventListener('pointerdown', this.#onDocumentPointerDown);
    if (!document.getElementById('wow-click-menu-style')) {
      const style = document.createElement('style');
      style.id = 'wow-click-menu-style';
      style.textContent = wowMenuStyle;
      document.head.appendChild(style);
    }
    this.querySelector('overflow-list')?.setAttribute('disabled', 'true');
    this.#markCurrentPage();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('keydown', this.#onKeydown);
        this.removeEventListener('click', this.#onHeadingClick, true);
    document.removeEventListener('pointerdown', this.#onDocumentPointerDown);
  }

  #prepareHeadings() {
      this.querySelectorAll('.menu-list__trigger > a').forEach((link) => {
            const item = link.closest('.menu-list__list-item');
                  const control = this.#expandableFor(link);
                        link.setAttribute('role', 'button');
                              link.setAttribute('aria-expanded', 'false');
                                    link.setAttribute('aria-controls', control.getAttribute('aria-controls'));
                                          const list = item.querySelector('.mega-menu__column');
                                                if (list && !list.querySelector('.wow-shop-category') && link.getAttribute('href') !== '#') {
                                                        const row = document.createElement('div');
                                                                const all = document.createElement('a');
                                                                        all.className = 'mega-menu__link wow-shop-category';
                                                                                all.href = link.href;
                                                                                        all.textContent = 'Shop all ' + link.textContent.trim();
                                                                                                row.append(all);
                                                                                                        list.prepend(row);
                                                                                                              }
                                                                                                                  });
                                                                                                                    }

                                                                                                                      #onHeadingClick = (event) => {
                                                                                                                          const link = event.target instanceof Element ? event.target.closest('.menu-list__trigger > a') : null;
                                                                                                                              if (!link || !this.contains(link)) return;
                                                                                                                                  event.preventDefault();
                                                                                                                                      event.stopImmediatePropagation();
                                                                                                                                          const item = findMenuItem(link);
                                                                                                                                              if (this.#state.activeItem === item) this.#close();
                                                                                                                                                  else this.#open(item);
                                                                                                                                                    };

                                                                                                                                                      #state = { activeItem: null };

  #onDocumentPointerDown = (event) => {
    if (!(event.target instanceof Node)) return;
    if (!this.contains(event.target)) this.#close();
  };

  #onKeydown = (event) => {
    if (event.key === ' ' && event.target.matches('.menu-list__trigger > a')) {
          event.preventDefault(); event.target.click(); return;
              }
                  if (event.key !== 'Escape' || !this.#state.activeItem) return;
    const control = this.#expandableFor(this.#state.activeItem);
    this.#close();
    control?.focus();
  };

  #markCurrentPage() {
    const current = window.location.pathname.replace(/\/$/, '') || '/';
    this.querySelectorAll('a[href]').forEach((link) => {
      link.classList.remove('wow-current-menu-link');
      link.removeAttribute('aria-current');
      const url = new URL(link.href, window.location.origin);
      const path = url.pathname.replace(/\/$/, '') || '/';
      if (path === current) {
        link.setAttribute('aria-current', 'page');
        link.classList.add('wow-current-menu-link');
      }
    });
  }

  toggle = (event) => {
    const control = event.target instanceof HTMLElement ? event.target : null;
    if (!control) return;
    const item = findMenuItem(control);
    if (!item) return;
    if (control.getAttribute('aria-expanded') === 'true') this.#close();
    else this.#open(item);
  };

  activate = (event) => {
    if (event?.type === 'pointerenter' || event?.type === 'pointerleave' || event?.type === 'blur') return;
    const target = event?.target instanceof Element ? event.target : null;
    const item = target ? findMenuItem(target) : null;
    if (item) this.#open(item);
  };

  deactivate = (event) => {
    if (event?.type === 'pointerleave' || event?.type === 'blur') return;
    this.#close();
  };

  #open(item) {
    const submenu = findSubmenu(item);
    const control = this.#expandableFor(item);
    if (!submenu || !control) return;
    this.#close(false);
    this.#state.activeItem = item;
    this.ariaExpanded = 'true';
    control.setAttribute('aria-expanded', 'true');
        item.setAttribute('aria-expanded', 'true');
    submenu.inert = false;
    submenu.dataset.active = '';
    requestAnimationFrame(() => {
      const height = submenu.offsetHeight;
      const header = this.headerComponent;
      if (header) {
        header.style.setProperty('--submenu-height', `${height}px`);
        header.style.setProperty('--full-open-header-height', `${height + header.offsetHeight}px`);
      }
      this.style.setProperty('--submenu-opacity', '1');
    });
  }

  #close(clearState = true) {
    const item = this.#state.activeItem;
    if (!item) return;
    const submenu = findSubmenu(item);
    const control = this.#expandableFor(item);
    const header = this.headerComponent;
    if (submenu) {
      submenu.inert = true;
      delete submenu.dataset.active;
    }
    control?.setAttribute('aria-expanded', 'false');
        item.setAttribute('aria-expanded', 'false');
    this.ariaExpanded = 'false';
    this.style.setProperty('--submenu-opacity', '0');
    header?.style.setProperty('--submenu-height', '0px');
    header?.style.setProperty('--full-open-header-height', '0px');
    if (clearState) this.#state.activeItem = null;
  }

  #expandableFor(item) {
    const listItem = item?.closest('.menu-list__list-item');
    const control = listItem?.querySelector('[ref="disclosure[]"]');
    return control instanceof HTMLElement ? control : item;
  }

  get headerComponent() { return this.closest('header-component'); }
}

if (!customElements.get('header-menu')) customElements.define('header-menu', HeaderMenu);

function findMenuItem(element) {
  if (!(element instanceof Element)) return null;
  const listItem = element.closest('.menu-list__list-item');
  const item = listItem?.querySelector('[ref="menuitem"]');
  return item instanceof HTMLElement ? item : null;
}

function findSubmenu(element) {
  const listItem = element?.closest?.('.menu-list__list-item');
  const submenu = listItem?.querySelector(':scope > [ref="submenu[]"]');
  return submenu instanceof HTMLElement ? submenu : null;
}
